import React from 'react'
import { Carousel } from "antd";

function Offerdata() {
    return (
        <div style={{ border: "10px solid rgb(234,234, 240)" }} >
            <Carousel autoplay>
                <div>
                    <img width="100%" style={{ objectFit: "contain" }} src="https://rukminim1.flixcart.com/flap/3376/560/image/57267a180af306fe.jpg?q=50" alt="" />
                </div>
                <div>
                    <img width="100%" style={{ objectFit: "contain" }} src="https://rukminim1.flixcart.com/flap/3376/560/image/ae9966569097a8b7.jpg?q=50" alt="" />
                </div>
                <div>
                    <img width="100%" style={{ objectFit: "contain" }} src="https://rukminim1.flixcart.com/flap/3376/560/image/d117a62eb5fbb8e1.jpg?q=50" alt="" />
                </div>
                <div>
                    <img width="100%" style={{ objectFit: "contain" }} src="https://rukminim1.flixcart.com/flap/3376/560/image/57267a180af306fe.jpg?q=50" alt="" />
                </div>
            </Carousel>
        </div>
    )
}

export default Offerdata